import type ConstructionListItem from "../pages/constructionsNew/types/ConstructionListItem";

/* eslint-disable @typescript-eslint/no-unsafe-argument */
export const formatDateToString = (date?: Date): string =>
  date === undefined
    ? ""
    : date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();

export const formatDateStringToString = (date?: string): string | undefined => {
  if (date !== undefined) {
    return formatDateToString(new Date(date));
  }
  return undefined;
};

export const formatDateStringToDate = (dateString?: string): Date => {
  if (dateString !== undefined) {
    if (dateString.includes("/")) {
      const dateParts = dateString.slice(0, dateString.indexOf(" ")).split("/");

      if (dateParts.length === 3) {
        const [day, month, year] = dateParts.map(Number);

        if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
          return new Date(year, month - 1, day);
        }
      }
    }
    return new Date(dateString);
  }
  throw new Error("Invalid date!");
};

export const getOrderByCreatedDate = (constructions: ConstructionListItem[]): ConstructionListItem[] => {
  return [...constructions].sort((a, b) => b.sortCreatedOn.localeCompare(a.sortCreatedOn));
};

export const formatDate = (
  input: Date | number | string,
  format: string = "DD/MM/YYYY HH:MM"
): string => {
  const d = new Date(input);

  if (isNaN(d.getTime())) {
    throw new Error("Invalid date");
  }

  const pad = (value: number): string =>
    value.toString().padStart(2, "0");

  const tokens: Record<string, string> = {
    DD: pad(d.getDate()),
    MM: pad(d.getMonth() + 1),
    YYYY: d.getFullYear().toString(),
    HH: pad(d.getHours()),
    mm: pad(d.getMinutes()),
  };

  return format
    .replace("YYYY", tokens.YYYY)
    .replace("DD", tokens.DD)
    .replace("HH", tokens.HH)
    .replace("mm", tokens.mm)
    .replace(/MM/g, tokens.MM);
};

